// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.boardingRoles_onboardingRoles__FI6mu {
  max-width: 340px;
  width: 100%;
  margin: 15px auto;
}
.boardingRoles_onboardingRoles__FI6mu .boardingRoles_roleButtons__gY6m6 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/onboardingCards/boardingRoles.module.scss"],"names":[],"mappings":"AAAA;EACC,gBAAA;EACA,WAAA;EACA,iBAAA;AACD;AACC;EACC,aAAA;EACA,sBAAA;EACA,QAAA;AACF","sourcesContent":[".onboardingRoles {\r\n\tmax-width: 340px;\r\n\twidth: 100%;\r\n\tmargin: 15px auto;\r\n\r\n\t.roleButtons {\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\t\tgap: 8px;\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"onboardingRoles": `boardingRoles_onboardingRoles__FI6mu`,
	"roleButtons": `boardingRoles_roleButtons__gY6m6`
};
export default ___CSS_LOADER_EXPORT___;
